import { render, staticRenderFns } from "./NavigationTree.vue?vue&type=template&id=38f4a514&"
import script from "./NavigationTree.vue?vue&type=script&lang=ts&"
export * from "./NavigationTree.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports